export type LoginPageMode = 'login' | 'register';

export const getLoginPageMode = (searchParams: URLSearchParams): LoginPageMode => (
  searchParams.get('mode') === 'register' ? 'register' : 'login'
);

export type LoginUrlTokenResult = {
  fragmentToken: string | null;
  sanitizedUrl: string;
  rejectedQueryToken: boolean;
};

/**
 * Bearer credentials are accepted only from the URL fragment. Fragments are
 * never sent to nginx, while query strings are present in the first HTTP
 * request and can escape into proxy logs, browser history, and referrers.
 */
export const readLoginUrlToken = (href: string): LoginUrlTokenResult => {
  const url = new URL(href);
  const fragment = new URLSearchParams(url.hash.replace(/^#/, ''));
  const rawFragmentToken = fragment.get('token');
  const fragmentToken = rawFragmentToken?.trim() || null;
  const rejectedQueryToken = url.searchParams.has('token');
  url.searchParams.delete('token');
  fragment.delete('token');
  const nextHash = fragment.toString();
  return {
    fragmentToken,
    sanitizedUrl: `${url.pathname}${url.search}${nextHash ? `#${nextHash}` : ''}`,
    rejectedQueryToken,
  };
};

export type WorkspaceHandoffUrlResult = {
  handoffCode: string | null;
  sanitizedUrl: string;
  rejectedQueryHandoff: boolean;
};

export const readWorkspaceHandoffUrl = (href: string): WorkspaceHandoffUrlResult => {
  const url = new URL(href);
  const fragment = new URLSearchParams(url.hash.replace(/^#/, ''));
  const handoffCode = fragment.get('handoff')?.trim() || null;
  const rejectedQueryHandoff = url.searchParams.has('handoff');
  url.searchParams.delete('handoff');
  fragment.delete('handoff');
  const nextHash = fragment.toString();
  return {
    handoffCode,
    sanitizedUrl: `${url.pathname}${url.search}${nextHash ? `#${nextHash}` : ''}`,
    rejectedQueryHandoff,
  };
};
